var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileVisImp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 0.5C6.89801 0.5 0.333496 7.4375 0.333496 16C0.333496 24.5625 6.89801 31.5 15.0002 31.5C23.1023 31.5 29.6668 24.5625 29.6668 16C29.6668 7.4375 23.1023 0.5 15.0002 0.5ZM15.0002 6.5C17.8744 6.5 20.2045 8.9625 20.2045 12C20.2045 15.0375 17.8744 17.5 15.0002 17.5C12.126 17.5 9.79586 15.0375 9.79586 12C9.79586 8.9625 12.126 6.5 15.0002 6.5ZM15.0002 28C11.5287 28 8.4179 26.3375 6.33618 23.7375C7.44801 21.525 9.62436 20 12.1615 20C12.3034 20 12.4453 20.025 12.5813 20.0688C13.3502 20.3313 14.1545 20.5 15.0002 20.5C15.8459 20.5 16.6561 20.3313 17.419 20.0688C17.555 20.025 17.6969 20 17.8389 20C20.376 20 22.5523 21.525 23.6641 23.7375C21.5824 26.3375 18.4717 28 15.0002 28Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileVisImp);
export default __webpack_public_path__ + "static/media/profileVisImp.aa1a1049c6b3b411f67aeaece4b31094453efe77e8b94d57826c5fb6d1559546.svg";
export { ForwardRef as ReactComponent };